import { useMutation } from "@tanstack/react-query";
import api from "../../utils/axiosInstance";
import { setTokens } from "../../utils/authTokenStore";
import { useSnackbar } from "notistack";

// Service function for login API call
export const loginAPI = async ({ email, password }) => {
 
  const response = await api.post("/token/", { username: email, password });
  return response.data;
};


export const useLoginService = () => {
  const { enqueueSnackbar } = useSnackbar();
//   const queryClient = useQueryClient();

  const { mutate, isLoading, isSuccess, data, error, isError } = useMutation({
    mutationFn: loginAPI,
    onSuccess: (data) => {
      setTokens({ access: data.access, refresh: data.refresh });
      enqueueSnackbar(data.message || "Logged in successfully!", { variant: "success" });
    
    },
    onError: (error) => {
      if (error?.response?.data?.detail) {
        enqueueSnackbar(error.response.data.detail, { variant: "error" });
      } else {
        enqueueSnackbar("Login failed", { variant: "error" });
      }
    },
  });

  return {
    login: mutate,
    isLoading,
    isSuccess,
    data,
    error,
    isError,
  };
};